import * as racersTranslationsPackage from '@nsftx/i18n-games-racers';

export default {
  name: 'greyhoundraces',
  maxRacerNumber: 6,
  eventId: '-',
  betInputData: {
    value: {},
    system: '',
  },
  offerList: [],
  activeOffer: {},
  editBetModeFeatureAllowed: false,
  translationPackage: racersTranslationsPackage,
};
